import ApiService from './_api.service'

const PRODUCTS_URL = '/v1/products/'
const BrandsService = {
    getBrands: async function(args) {
        const resource = PRODUCTS_URL + 'brands'
        const url = args ? `${resource}?name=${args}` : resource + '/'
        return ApiService.get(url)
    }
}

export default BrandsService
export { BrandsService }
